import { supabase } from './supabase';

// Gallery albums and photos (tables gallery_albums / gallery_images; files in the public Storage bucket `gallery`).
export const BUCKET = 'gallery';
export const PHOTO_COLUMNS = 'id, album_id, storage_path, alt_text, caption, width, height, sort_order, created_at';
// Albums and photos are linked twice (photos belong to an album; an album's cover is one of its photos), so an
// album's photos must be embedded through the album_id foreign key by name, or the API refuses the query (PGRST201).
// The result is still under `gallery_images`.
export const albumPhotos = (columns) => `gallery_images!gallery_images_album_id_fkey(${columns})`;

export const photoUrl = (path) => supabase.storage.from(BUCKET).getPublicUrl(path).data.publicUrl;

// Photos in display order: position, then upload time.
export const sortPhotos = (photos) =>
  [...(photos ?? [])].sort((a, b) => a.sort_order - b.sort_order || String(a.created_at).localeCompare(String(b.created_at)));

// The shape the public Gallery page renders (the same as the sample albums).
export const toPublicAlbum = (row) => {
  const photos = sortPhotos(row.gallery_images);
  const images = photos.map((p) => ({
    id: p.id, src: photoUrl(p.storage_path), alt: p.alt_text, caption: p.caption, width: p.width, height: p.height
  }));
  const coverIndex = Math.max(0, photos.findIndex((p) => p.id === row.cover_image_id));
  return { id: row.id, title: row.title, category: row.category, description: row.description, images, coverIndex };
};

// Published albums for visitors (row-level security returns only published albums and their photos).
export const fetchPublishedAlbums = async () => {
  const { data, error } = await supabase
    .from('gallery_albums')
    .select(`id, title, description, category, cover_image_id, ${albumPhotos(PHOTO_COLUMNS)}`)
    .eq('is_published', true)
    .order('sort_order', { ascending: true })
    .order('published_at', { ascending: false });
  if (error) throw error;
  return (data ?? []).map(toPublicAlbum).filter((album) => album.images.length > 0);
};
